import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const EmailWithPaintDropSvg = () => (
  <svg
    width='1em'
    height='0.946em'
    viewBox='0 0 37 35'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      opacity='0.5'
      d='M23.2852 1.45705C25.3908 0.788527 27.3578 2.01845 27.6787 4.20415L28.9653 12.967C30.0197 20.1488 25.266 27.7515 18.3476 29.9481C10.4175 32.466 3.00915 27.8338 1.80052 19.6018L1.68566 18.8195C0.871814 13.2764 4.54083 7.40845 9.88064 5.71305L23.2852 1.45705Z'
      fill='url(#paint0_linear_2922_10459)'
    />
    <path
      d='M16.7871 10.1156H32.7871C33.8871 10.1156 34.7871 11.0156 34.7871 12.1156V24.1156C34.7871 25.2156 33.8871 26.1156 32.7871 26.1156H16.7871C15.6871 26.1156 14.7871 25.2156 14.7871 24.1156V12.1156C14.7871 11.0156 15.6871 10.1156 16.7871 10.1156Z'
      stroke='#3F3D56'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M34.7871 12.1156L24.7871 19.1156L14.7871 12.1156'
      stroke='#3F3D56'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_2922_10459'
        x1='17.2804'
        y1='-0.118888'
        x2='31.6428'
        y2='13.2741'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#D58405' />
        <stop offset='0.396113' stopColor='#F39C12' />
        <stop offset='1' stopColor='#EEB457' />
      </linearGradient>
    </defs>
  </svg>
);

export const EmailWithPaintDropIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={EmailWithPaintDropSvg} {...props} />
);
